import { render, staticRenderFns } from "./AttractionCardVariant4.vue?vue&type=template&id=02918814&scoped=true&"
import script from "./AttractionCardVariant4.vue?vue&type=script&lang=js&"
export * from "./AttractionCardVariant4.vue?vue&type=script&lang=js&"
import style0 from "./AttractionCardVariant4.vue?vue&type=style&index=0&id=02918814&lang=scss&scoped=true&"
import style1 from "./AttractionCardVariant4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02918814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VFadeTransition,VFlex,VIcon,VImg})
